import React, { useState, useEffect } from 'react';
import api from '../../api';

const SettingContext = React.createContext({});
const SettingConsumer = SettingContext.Consumer;

const SettingProvider = ({ children }) => {
    const [siteSettings, setSiteSettings] = useState([]);
    const [sliderVideo, setSliderVideo] = useState([]);

    const getAllSiteSettings = async () => {
        const res = await api.get('/setting/site');
        const settings = res.data.data.siteSettings;

        // settings.find(s => s.settingName === 'SLIDER_VIDEO')?.settingValue;
        setSiteSettings(settings);
    }

    useEffect(() => {
        getAllSiteSettings();
    }, []);

    return (
        <SettingContext.Provider value={{ siteSettings }}>
            {children}
        </SettingContext.Provider>
    )
}

export { SettingContext, SettingConsumer, SettingProvider }; 